<dashboard-header title="My Journey" titleCssIcon="journey-icon" [showStatus]="true" [showPendingTasks]="true">
</dashboard-header>
<div class="container-fluid dashboard-journey">

    <div class="mt-5 pb-4 row" style="border-bottom: 1px rgb(255, 255, 255) solid;">
        <div class="col-6 font-weight-bold">
            <h2>My Activities</h2>
        </div>
        <div class="col-6 text-right">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M21 14H14V21H21V14Z" fill="white" />
                <path d="M10 14H3V21H10V14Z" fill="white" />
                <path d="M21 3H14V10H21V3Z" fill="white" />
                <path d="M10 3H3V10H10V3Z" fill="white" />
            </svg>

        </div>
    </div>



    <div class="row pt-3">

         <div class="col-6 text-uppercase mb-4 mt-4">
            <h3 style="font-style: italic;">Wayfinding</h3>
        </div>

        <div class="col-6 text-uppercase mb-4 mt-4 text-right">
            <h3 style="font-style: italic;">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M15.9998 29.3337C23.3636 29.3337 29.3332 23.3641 29.3332 16.0003C29.3332 8.63653 23.3636 2.66699 15.9998 2.66699C8.63604 2.66699 2.6665 8.63653 2.6665 16.0003C2.6665 23.3641 8.63604 29.3337 15.9998 29.3337Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M18.8267 18.8267L21.6533 10.3467L13.1733 13.1733L18.8267 18.8267Z" fill="white"/>
                    </svg>
            </h3>
        </div>


        <div class="col-12 journey-course" *ngFor="let course of courses; let i=index">
            <div class="journey-course-wrapper">
                <div 
                    [ngClass]="{'light-theme border-top': true, 'started' : course.currentSection > 0, 'completed': course.finished, 'available': course.available, 'notAvailable': !course.available }">
                    <div class="row no-gutters pr-lg-0 journey-course-detail-{{i}} collapse {{course.expandedShow}}">
                        <div class="col-12 col-lg-6 order-1 order-lg-3 px-0 journey-course-image"
                            [ngStyle]="{'background-image': 'url(' + course.featuredImageUrl + ')'}">
                        </div>
                        <div class="col-12 order-2 order-lg-1 text-center position-relative border-lg-bottom">
                            <div class="position-relative d-lg-none"
                                *ngIf="course.currentSection > 0 && course.percentage < 100">
                                <div class="full-progress-bar"></div>
                                <div class="progress-bar" [ngStyle]="{'width.%': course.percentage}"></div>
                            </div>
                            <div class="footnote text-blue px-3 pt-4"
                                *ngIf="course.currentSection > 0 && course.percentage < 100">
                                {{course.percentage| number:'1.0-0'}}% completed
                            </div>
                            <div class="footnote text-blue px-3 pt-2"
                                *ngIf="course.finished">
                                completed
                            </div>
                            <div class="d-flex flex-column flex-lg-row align-items-center justify-content-center">
                                <h2 class="font-weight-bold py-4">{{course.name}}</h2>
                                <div data-toggle="collapse" attr.data-target=".journey-course-detail-{{i}}"
                                    aria-expanded="false" aria-controls="journey-course-detail"
                                    class="journey-course-collapse position-absolute d-none d-lg-block">
                                </div>
                            </div>
                            <div class="position-relative d-none d-lg-block"
                                *ngIf="course.currentSection > 0 && !course.finished">
                                <div class="full-progress-bar"></div>
                                <div class="progress-bar" [ngStyle]="{'width.%': course.percentage}"></div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6  journey-course-info order-3 order-lg-2 pt-0 pb-4 px-3 p-lg-4">
                            <div class="journey-course-description text-center text-xlarge py-4 border-bottom"
                                [innerHtml]="course.description"></div>
                            <div class="journey-course-goal py-4 border-bottom">
                                <div class="subtitle pb-3">Activity Goal</div>
                                <div class="" [innerHtml]="course.activityGoal"></div>
                            </div>

                            <ng-container *ngIf="course.finished">
                                <div class="py-4 d-flex">
                                    <a href="#" (click)="getIntro(course.courseId)" role="button" class="btn btn-secondary px-5 mr-4">Review Activity</a>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="!course.finished">
                                <div class="journey-course-preparation py-4 border-bottom">
                                    <div class="subtitle pb-3">Before you begin</div>
                                    <div class="" [innerHtml]="course.beforeYouBegin"></div>
                                </div>
                                <div
                                    class="journey-course-toolbar d-flex justify-content-between align-items-center py-4">
                                    <div class="journey-course-duration">
                                        <svg class="mr-1" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 6V12L16 14" stroke="black" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                        <span>{{course.duration}}</span>
                                    </div>
                                    <a *ngIf="course.available && continueToSection(course)"
                                        href="/course-section/{{course.nextSectionId}}" role="button"
                                        class="btn btn-primary px-4"
                                        [innerHtml]=" continueToSection(course) && course.currentSection > 0 ? 'continue activity' : 'start activity' "></a>
                                    <a *ngIf="course.available && continueToPreCourse(course)"
                                        href="/{{course.preCourseComponent}}/{{course.courseId}}" role="button"
                                        class="btn btn-primary px-4"
                                        [innerHtml]=" course.currentSection == 0 ? 'start activity' : 'continue activity' "></a>
                                    <a *ngIf="!course.available" href="#" role="button"
                                        class="btn btn-locked px-4 disabled">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M13.7658 8.25H3.62261C2.82234 8.25 2.17358 8.92157 2.17358 9.75V15C2.17358 15.8284 2.82234 16.5 3.62261 16.5H13.7658C14.5661 16.5 15.2148 15.8284 15.2148 15V9.75C15.2148 8.92157 14.5661 8.25 13.7658 8.25Z"
                                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                                d="M5.07153 8.25V5.25C5.07153 4.25544 5.4532 3.30161 6.13256 2.59835C6.81192 1.89509 7.73334 1.5 8.69411 1.5C9.65487 1.5 10.5763 1.89509 11.2557 2.59835C11.935 3.30161 12.3167 4.25544 12.3167 5.25V8.25"
                                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </a>
                                </div>
                            </ng-container>
                            <div class="d-flex align-items-center justify-content-center pt-3 d-lg-none">
                                <div data-toggle="collapse" attr.data-target=".journey-course-detail-{{i}}"
                                    aria-expanded="false" aria-controls="journey-course-detail"
                                    class="journey-course-collapse">
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row no-gutters pr-lg-0  journey-course-detail-{{i}} collapse {{course.collapsedShow}} ">
                        <div class="col-12 col-md-5 col-lg-3 px-0 journey-course-image journey-course-image-collapsed order-1 order-md-2 "
                            [ngStyle]="{'background-image': 'url(' + course.featuredImageUrl + ')'}">
                        </div>
                        <div class="col-12 col-md-7 col-lg-9 p-3 p-lg-4 order-3 order-md-1">
                            <div class="footnote text-blue pt-2" *ngIf="course.currentSection > 0">
                                {{course.percentage| number:'1.0-0'}}% completed</div>
                            <div class="footnote text-blue pt-4" *ngIf="course.finished">
                                completed
                            </div>
                            <div class="d-flex align-items-center justify-content-between">
                                <h2 class="font-weight-bold py-3">{{course.name}}</h2>
                                <div data-toggle="collapse" attr.data-target=".journey-course-detail-{{i}}"
                                    aria-expanded="false" aria-controls="journey-course-detail"
                                    class="journey-course-expand d-none d-lg-block">
                                </div>
                            </div>
                            <div class="journey-course-description" [innerHtml]="course.description"></div>
                            <div class="d-flex align-items-center justify-content-center pt-3 d-lg-none"
                                data-toggle="collapse" attr.data-target=".journey-course-detail-{{i}}"
                                aria-expanded="false" aria-controls="journey-course-detail">
                                <div class="journey-course-expand">
                                </div>
                            </div>
                        </div>
                        <div class="position-relative w-100 order-2 order-lg-3"
                            *ngIf="course.currentSection > 0 && !course.finished">
                            <div class="full-progress-bar"></div>
                            <div class="progress-bar" [ngStyle]="{'width.%': course.percentage}"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row pt-3">
        <div class="col-6 text-uppercase mb-4 mt-4">
            <h3 style="font-style: italic;">North Star</h3>
        </div>

        <div class="col-6 text-uppercase mb-4 mt-4 text-right">
            <h3 style="font-style: italic;">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <path d="M17.6177 0.24714L16.3886 8.95195C15.8423 12.8513 12.7831 15.9268 8.90445 16.476L0.245828 17.7117C-0.0819428 17.7666 -0.0819428 18.2334 0.245828 18.2883L8.90445 19.524C12.7831 20.0732 15.8423 23.1487 16.3886 27.0481L17.6177 35.7529C17.6723 36.0824 18.1367 36.0824 18.1913 35.7529L19.4205 27.0481C19.9667 23.1487 23.0259 20.0732 26.9046 19.524L35.5632 18.2883C35.891 18.2334 35.891 17.7666 35.5632 17.7117L26.9046 16.476C23.0259 15.9268 19.9667 12.8513 19.4205 8.95195L18.1913 0.24714C18.1367 -0.0823799 17.6723 -0.0823799 17.6177 0.24714Z" fill="white"/>
                    </svg>
            </h3>
        </div>

        <div class="col-12 journey-course" *ngFor="let northStars of northnearstarscourse;let i=index">
            <div *ngIf="northStars.typeStartCourse == 1" class="journey-course-wrapper">
                <div class="{{datarespond}} border-top">
                    <div
                        class="row no-gutters pr-lg-0 info-course-detail-{{northStars.id}} collapse {{northStars.expandedShow}}">
                        <div class="col-12 col-lg-6 order-1 order-lg-3 px-0 journey-course-image"
                            [ngStyle]="{'background-image': 'url(' + northStars.featuredImageUrl + ')'}">
                        </div>
                        <div class="col-12 order-2 order-lg-1 text-center position-relative border-lg-bottom">
                            <div class="d-flex flex-column flex-lg-row align-items-center justify-content-center">
                                <h2 class="font-weight-bold py-4">{{northStars.name}} </h2>
                                <div data-toggle="collapse" attr.data-target=".info-course-detail-{{northStars.id}}"
                                    aria-expanded="false" aria-controls="info-course-detail"
                                    class="journey-course-collapse position-absolute d-none d-lg-block">
                                </div>
                            </div>

                        </div>
                        <div class="col-12 col-lg-6  journey-course-info order-3 order-lg-2 pt-0 pb-4 px-3 p-lg-4">
                            <div class="journey-course-description text-center text-xlarge py-4 border-bottom"
                                [innerHtml]="northStars.description"></div>
                            <div class="journey-course-goal py-4 border-bottom">
                                <div class="subtitle pb-3">Activity Goal</div>
                                <div class="" [innerHtml]="northStars.activityGoal"></div>
                            </div>
                            <ng-container>
                                <div class="journey-course-preparation py-4 border-bottom">
                                    <div class="subtitle pb-3">Before you begin</div>
                                    <div class="" [innerHtml]="northStars.beforeYouBegin"></div>
                                </div>
                                <div
                                    class="journey-course-toolbar d-flex justify-content-between align-items-center py-4">
                                    <div class="journey-course-duration">
                                        <svg class="mr-1" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 6V12L16 14" stroke="black" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                        <span>{{northStars.duration}}</span>
                                    </div>
                                    <p>Complete this activity as a:</p>
                                    <div *ngIf="botonshow">

                                        <a class="btn btn-primary px-5" target="_blank" href="{{northStars.featuredDocumentUrl}}">Google document</a>
                                    </div>


                                    <a href="#" role="button" *ngIf="botonhidden" class="btn btn-locked px-4 disabled">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M13.7658 8.25H3.62261C2.82234 8.25 2.17358 8.92157 2.17358 9.75V15C2.17358 15.8284 2.82234 16.5 3.62261 16.5H13.7658C14.5661 16.5 15.2148 15.8284 15.2148 15V9.75C15.2148 8.92157 14.5661 8.25 13.7658 8.25Z"
                                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                                d="M5.07153 8.25V5.25C5.07153 4.25544 5.4532 3.30161 6.13256 2.59835C6.81192 1.89509 7.73334 1.5 8.69411 1.5C9.65487 1.5 10.5763 1.89509 11.2557 2.59835C11.935 3.30161 12.3167 4.25544 12.3167 5.25V8.25"
                                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </a>

                                </div>
                            </ng-container>
                            <div class="d-flex align-items-center justify-content-center pt-3 d-lg-none">
                                <div data-toggle="collapse" attr.data-target=".info-course-detail-{{northStars.id}}"
                                    aria-expanded="false" aria-controls="info-course-detail"
                                    class="info-course-collapse">
                                </div>
                            </div>

                        </div>
                    </div>
                    <div
                        class="row no-gutters pr-lg-0  info-course-detail-{{northStars.id}} collapse {{northStars.collapsedShow}}">
                        <div class="col-12 col-md-5 col-lg-3 px-0 journey-course-image journey-course-image-collapsed order-1 order-md-2 "
                            [ngStyle]="{'background-image': 'url(' + northStars.featuredImageUrl + ')'}">
                        </div>
                        <div class="col-12 col-md-7 col-lg-9 p-3 p-lg-4 order-3 order-md-1">

                            <div class="d-flex align-items-center justify-content-between">
                                <h2 class="font-weight-bold py-3">{{northStars.name}}</h2>
                                <div data-toggle="collapse" attr.data-target=".info-course-detail-{{northStars.id}}"
                                    aria-expanded="false" aria-controls="info-course-detail"
                                    class="journey-course-expand d-none d-lg-block">
                                </div>
                            </div>
                            <div class="journey-course-description" [innerHtml]="northStars.description"></div>
                            <div class="d-flex align-items-center justify-content-center pt-3 d-lg-none"
                                data-toggle="collapse" attr.data-target=".info-course-detail-{{northStars.id}}"
                                aria-expanded="false" aria-controls="info-course-detail">
                                <div class="journey-course-expand">
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row pt-3">
        <div class="col-6 text-uppercase mb-4 mt-4">
            <h3 style="font-style: italic;">Near Stars</h3>
        </div>

        <div class="col-6 text-uppercase mb-4 mt-4 text-right">
            <h3 style="font-style: italic;">
                <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
                    <path d="M31.2551 0.225079L30.1859 7.76107C29.7181 11.1289 27.0449 13.7965 23.6366 14.2967L16.0849 15.3637C15.7842 15.3971 15.7842 15.8306 16.0849 15.8639L23.6366 16.931C27.0115 17.3978 29.6846 20.0654 30.1859 23.4666L31.2551 31.0026C31.2885 31.3027 31.7229 31.3027 31.7563 31.0026L32.8256 23.4666C33.2934 20.0987 35.9666 17.4311 39.3749 16.931L46.9266 15.8639C47.2273 15.8306 47.2273 15.3971 46.9266 15.3637L39.3749 14.2967C36 13.8299 33.3268 11.1623 32.8256 7.76107L31.7563 0.225079C31.6895 -0.0750265 31.2885 -0.0750265 31.2551 0.225079Z" fill="white"/>
                    <path d="M13.5121 19.4641L12.6099 25.6663C12.2089 28.4673 10.0035 30.6347 7.23012 31.0349L0.981579 31.9352C0.747677 31.9685 0.747677 32.302 0.981579 32.3353L7.19671 33.2356C10.0035 33.6358 12.1755 35.8366 12.5765 38.6042L13.4787 44.8064C13.5121 45.0398 13.8462 45.0398 13.8796 44.8064L14.7818 38.6042C15.1828 35.8032 17.3882 33.6358 20.1616 33.2356L26.4101 32.3353C26.644 32.302 26.644 31.9685 26.4101 31.9352L20.195 31.0349C17.3882 30.6681 15.1828 28.4673 14.8153 25.6663L13.9131 19.4641C13.8796 19.2307 13.5455 19.2307 13.5121 19.4641Z" fill="white"/>
                    <path d="M39.1076 28.836L38.4393 33.5043C38.1385 35.605 36.5012 37.2389 34.3961 37.539L29.7181 38.2059C29.551 38.2393 29.551 38.5061 29.7181 38.5061L34.3961 39.173C36.5012 39.4731 38.1385 41.107 38.4393 43.2077L39.1076 47.876C39.141 48.0428 39.4083 48.0428 39.4083 47.876L40.0766 43.2077C40.3773 41.107 42.0146 39.4731 44.1198 39.173L48.7978 38.5061C48.9649 38.4727 48.9649 38.2059 48.7978 38.2059L44.1198 37.539C42.0146 37.2389 40.3773 35.605 40.0766 33.5043L39.4083 28.836C39.4083 28.6693 39.141 28.6693 39.1076 28.836Z" fill="white"/>
                    </svg>
            </h3>
        </div>

        <div class="col-12 journey-course" *ngFor="let nearStars of northnearstarscourse;let i=index">
            <div *ngIf="nearStars.typeStartCourse == 2" class="journey-course-wrapper">
                <div class="{{datarespond}} border-top">
                    <div
                        class="row no-gutters pr-lg-0 info-course-detail-{{nearStars.id}} collapse {{nearStars.expandedShow}}">
                        <div class="col-12 col-lg-6 order-1 order-lg-3 px-0 journey-course-image"
                            [ngStyle]="{'background-image': 'url(' + nearStars.featuredImageUrl + ')'}">
                        </div>
                        <div class="col-12 order-2 order-lg-1 text-center position-relative border-lg-bottom">
                            <div class="d-flex flex-column flex-lg-row align-items-center justify-content-center">
                                <h2 class="font-weight-bold py-4">{{nearStars.name}} </h2>
                                <div data-toggle="collapse" attr.data-target=".info-course-detail-{{nearStars.id}}"
                                    aria-expanded="false" aria-controls="info-course-detail"
                                    class="journey-course-collapse position-absolute d-none d-lg-block">
                                </div>
                            </div>

                        </div>
                        <div class="col-12 col-lg-6  journey-course-info order-3 order-lg-2 pt-0 pb-4 px-3 p-lg-4">
                            <div class="journey-course-description text-center text-xlarge py-4 border-bottom"
                                [innerHtml]="nearStars.description"></div>
                            <div class="journey-course-goal py-4 border-bottom">
                                <div class="subtitle pb-3">Activity Goal</div>
                                <div class="" [innerHtml]="nearStars.activityGoal"></div>
                            </div>
                            <ng-container>
                                <div class="journey-course-preparation py-4 border-bottom">
                                    <div class="subtitle pb-3">Before you begin</div>
                                    <div class="" [innerHtml]="nearStars.beforeYouBegin"></div>
                                </div>
                                <div
                                    class="journey-course-toolbar d-flex justify-content-between align-items-center py-4">
                                    <div class="journey-course-duration">
                                        <svg class="mr-1" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 6V12L16 14" stroke="black" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                        <span>{{nearStars.duration}}</span>
                                    </div>
                                    <p>Complete this activity as a:</p>
                                    <div *ngIf="botonshow">
                                        
                                        <!-- <button class="btn btn-primary px-5" href="{{nearStars.featuredDocumentUrl}}">Google document</button> -->
                                        <a class="btn btn-primary px-5" target="_blank" href="{{nearStars.featuredDocumentUrl}}">Google document</a>
                                    </div>


                                    <a href="#" role="button" *ngIf="botonhidden" class="btn btn-locked px-4 disabled">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M13.7658 8.25H3.62261C2.82234 8.25 2.17358 8.92157 2.17358 9.75V15C2.17358 15.8284 2.82234 16.5 3.62261 16.5H13.7658C14.5661 16.5 15.2148 15.8284 15.2148 15V9.75C15.2148 8.92157 14.5661 8.25 13.7658 8.25Z"
                                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                                d="M5.07153 8.25V5.25C5.07153 4.25544 5.4532 3.30161 6.13256 2.59835C6.81192 1.89509 7.73334 1.5 8.69411 1.5C9.65487 1.5 10.5763 1.89509 11.2557 2.59835C11.935 3.30161 12.3167 4.25544 12.3167 5.25V8.25"
                                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </a>

                                </div>
                            </ng-container>
                            <div class="d-flex align-items-center justify-content-center pt-3 d-lg-none">
                                <div data-toggle="collapse" attr.data-target=".info-course-detail-{{nearStars.id}}"
                                    aria-expanded="false" aria-controls="info-course-detail"
                                    class="info-course-collapse">
                                </div>
                            </div>

                        </div>
                    </div>
                    <div
                        class="row no-gutters pr-lg-0  info-course-detail-{{nearStars.id}} collapse {{nearStars.collapsedShow}}">
                        <div class="col-12 col-md-5 col-lg-3 px-0 journey-course-image journey-course-image-collapsed order-1 order-md-2 "
                            [ngStyle]="{'background-image': 'url(' + nearStars.featuredImageUrl + ')'}">
                        </div>
                        <div class="col-12 col-md-7 col-lg-9 p-3 p-lg-4 order-3 order-md-1">

                            <div class="d-flex align-items-center justify-content-between">
                                <h2 class="font-weight-bold py-3">{{nearStars.name}}</h2>
                                <div data-toggle="collapse" attr.data-target=".info-course-detail-{{nearStars.id}}"
                                    aria-expanded="false" aria-controls="info-course-detail"
                                    class="journey-course-expand d-none d-lg-block">
                                </div>
                            </div>
                            <div class="journey-course-description" [innerHtml]="nearStars.description"></div>
                            <div class="d-flex align-items-center justify-content-center pt-3 d-lg-none"
                                data-toggle="collapse" attr.data-target=".info-course-detail-{{nearStars.id}}"
                                aria-expanded="false" aria-controls="info-course-detail">
                                <div class="journey-course-expand">
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="row py-5" *ngIf="allCoursesCompleted">

        <div class="col-12 text-center">
            <svg width="316" height="72" viewBox="0 0 316 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M283.487 0.459954L281.291 16.6606C280.314 23.9176 274.847 29.6415 267.915 30.6636L252.439 32.9634C251.854 33.0656 251.854 33.9344 252.439 34.0366L267.915 36.3364C274.847 37.3585 280.314 43.0824 281.291 50.3394L283.487 66.54C283.585 67.1533 284.415 67.1533 284.513 66.54L286.709 50.3394C287.686 43.0824 293.153 37.3585 300.085 36.3364L315.561 34.0366C316.146 33.9344 316.146 33.0656 315.561 32.9634L300.085 30.6636C293.153 29.6415 287.686 23.9176 286.709 16.6606L284.513 0.459954C284.415 -0.153318 283.585 -0.153318 283.487 0.459954Z"
                    fill="white" />
                <path
                    d="M158 61.4163C173.648 61.4163 186.333 48.9176 186.333 33.4997C186.333 18.0817 173.648 5.58301 158 5.58301C142.352 5.58301 129.667 18.0817 129.667 33.4997C129.667 48.9176 142.352 61.4163 158 61.4163Z"
                    stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M164.006 39.4181L170.013 21.6631L151.993 27.5814L164.006 39.4181Z" fill="white" />
                <path
                    d="M40.5247 5.02841L39.1016 15.5924C38.479 20.3134 34.9213 24.0529 30.3853 24.754L20.3348 26.2498C19.9346 26.2965 19.9346 26.9042 20.3348 26.9509L30.3853 28.4467C34.8769 29.1011 38.4345 32.8406 39.1016 37.6084L40.5247 48.1723C40.5691 48.593 41.1473 48.593 41.1917 48.1723L42.6148 37.6084C43.2374 32.8873 46.7951 29.1479 51.3311 28.4467L61.3816 26.9509C61.7818 26.9042 61.7818 26.2965 61.3816 26.2498L51.3311 24.754C46.8396 24.0996 43.2819 20.3602 42.6148 15.5924L41.1917 5.02841C41.1028 4.60772 40.5691 4.60772 40.5247 5.02841Z"
                    fill="white" />
                <path
                    d="M16.9101 31.9983L15.7094 40.6926C15.1757 44.619 12.2406 47.6573 8.54955 48.2182L0.233473 49.4803C-0.0778242 49.527 -0.0778242 49.9944 0.233473 50.0412L8.50508 51.3032C12.2406 51.8642 15.1313 54.9492 15.6649 58.8289L16.8656 67.5231C16.9101 67.8503 17.3548 67.8503 17.3993 67.5231L18.6 58.8289C19.1336 54.9025 22.0687 51.8642 25.7598 51.3032L34.0759 50.0412C34.3872 49.9944 34.3872 49.527 34.0759 49.4803L25.8043 48.2182C22.0687 47.704 19.1336 44.619 18.6445 40.6926L17.4437 31.9983C17.3993 31.6711 16.9546 31.6711 16.9101 31.9983Z"
                    fill="white" />
                <path
                    d="M50.9751 45.1343L50.0857 51.6783C49.6854 54.6231 47.5064 56.9135 44.7047 57.3342L38.4788 58.2691C38.2564 58.3158 38.2564 58.6898 38.4788 58.6898L44.7047 59.6246C47.5064 60.0453 49.6854 62.3358 50.0857 65.2806L50.9751 71.8246C51.0196 72.0583 51.3753 72.0583 51.3753 71.8246L52.2648 65.2806C52.665 62.3358 54.8441 60.0453 57.6457 59.6246L63.8717 58.6898C64.094 58.643 64.094 58.2691 63.8717 58.2691L57.6457 57.3342C54.8441 56.9135 52.665 54.6231 52.2648 51.6783L51.3753 45.1343C51.3753 44.9006 51.0196 44.9006 50.9751 45.1343Z"
                    fill="white" />
            </svg>
        </div>
        <div class="col-12 text-center py-3">
            <h2>More activies coming soon</h2>
        </div>
        <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
            We are busy building your equity journey. Sign up for updates on new activities, new features, and
            improvements to your <b class="text-italic">Equity Is Dynamic: Journey</b> experience.
        </div>

        <div class="col-12 text-center pt-4">
            <a href="#" role="button" class="btn btn-primary px-lg-5">Get Updates</a>
        </div>
    </div>
</div>